<app-filter-dialog #filtrarMes (onSeleccionar)="filtrarMesOnSeleccionar($event)"/>
<section class="dash-page">
  <app-filter-dashboard (changesDates)="changeDates($event)" [suggestions]="true"/>
  <div class="dash-content">
    <div class="grid">

      <div class="col-12">
        <div class="dash-card">
          <div class="dash-header">
            <div>
              <h2 class="dash-title">{{ translations.titulo1 }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-chart-bar [config]="barConfig" class="flex-1" style="min-width:180px"/>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="dash-card">
          <div class="dash-header">
            <div>
              <h2 class="dash-title">{{ configTable.title }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-dashboard-table [config]="configTable"/>
          </div>
        </div>
      </div>


    </div>
  </div>
</section>
